<template>
  <div></div>
   <!-- <div class="navbar navbar-expand-lg navbar-dark copyright">
      <span
        class="copyrightFont"
      > -->
<!--        @2011-2020版权所有：中国数字科技馆未经书面许可任何人不得复制或镜像-->
<!--        京ICP备11000850号-->
<!--        京公网安备110105007388号-->
<!--        信息网络传播视听节目许可证0111611号-->
<!--        国家科技基础条件平台-->
        <!-- {{ rights }}
      </span>
    </div> -->
</template>

<script>

import {siteMess} from '@/api/system/index'
export default {
  name: 'Footer',
  data () {
    return {
      rights: ''
    }
  },
  created () {
    siteMess(this.siteURL, this.siteId).then(res => {
      this.rights = res.data.copyright
    })
  }
}
</script>

<style scoped>
.copyright {
  background: #002f71;
  width: 100%;
}
.copyrightFont {
  text-align: center;
  color: #4f6f9d;
  width: 100%;
  font-size: 13px;
}
</style>



// WEBPACK FOOTER //
// src/views/Footer.vue